import React, { useCallback, useEffect } from 'react'
import './search.css'
import { useDispatch, useSelector } from 'react-redux';
import { directSerachFalse, fetchData, fetchInput } from '../../redux/Slices/slice';

const Search = ({setDirectSearch, directSearch}) => {
  const dispatch = useDispatch()
  const { directSearchValue} = useSelector(state => state.Store)

    const handleButtonClick = (e) => {

      e.preventDefault()

      setDirectSearch(false)
      dispatch(directSerachFalse())

        let inputValue = ''
        inputValue = e.target.serch.value;
      
      if(inputValue==='') {
        alert("Write SomeThing first")
      } else{
        dispatch(fetchInput(inputValue));
        dispatch(fetchData(inputValue));
      }

      e.target.reset()
    };


    const directSerchFunction = useCallback(() => {

      setDirectSearch(true)
      dispatch(directSerachFalse(true))
      dispatch(fetchInput(directSearchValue));
      dispatch(fetchData(directSearchValue));

    },[directSearchValue,dispatch,setDirectSearch])

   

    useEffect(()=>{
      if(directSearch===true){
        directSerchFunction()
        setDirectSearch(true)
      }
    }, [directSerchFunction,directSearch,setDirectSearch]);

 
  return (
    <div className='searchComponent'>
        <form onSubmit={handleButtonClick} className='searchArea'>
            <input name='serch' type="textArea" placeholder='Type Here ...' className='inputField'/>
            <button className='uploadBtn' type='submit'>Go</button>
        </form>
        <p className='waterMark'>Developed and design by Saddam Anwar</p>
    </div>
  )
}
export default Search
